// Mock data for AI News Blog

export const mockArticles = [
  {
    id: '1',
    title: 'OpenAI Announces GPT-5: The Next Generation of Language Models',
    excerpt: 'OpenAI has unveiled GPT-5, featuring unprecedented reasoning capabilities and multimodal understanding that pushes the boundaries of artificial intelligence.',
    category: 'AI News',
    source: 'OpenAI Blog',
    sourceUrl: 'https://openai.com/news/',
    articleUrl: 'https://openai.com/index/introducing-gpt-4o-and-more-tools-to-chatgpt-free-users/',
    imageUrl: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800',
    publishedAt: '2024-11-15',
    featured: true
  },
  {
    id: '2',
    title: 'TensorFlow 3.0 Released with Major Performance Improvements',
    excerpt: 'Google announces TensorFlow 3.0 with up to 40% faster training times and improved support for edge devices and mobile deployment.',
    category: 'Tools',
    source: 'TensorFlow Blog',
    sourceUrl: 'https://blog.tensorflow.org/',
    articleUrl: 'https://blog.tensorflow.org/2024/09/tensorflow-210-released-with-new-features.html',
    imageUrl: 'https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=800',
    publishedAt: '2024-11-14',
    featured: false
  },
  {
    id: '3',
    title: 'MIT Researchers Develop Energy-Efficient Neural Networks',
    excerpt: 'New breakthrough in neural network architecture reduces energy consumption by 90% while maintaining accuracy, paving the way for sustainable AI.',
    category: 'Research Papers',
    source: 'MIT News',
    sourceUrl: 'https://news.mit.edu/topic/artificial-intelligence2',
    articleUrl: 'https://news.mit.edu/2024/mit-researchers-advance-automated-interpretability-large-language-models-1031',
    imageUrl: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=800',
    publishedAt: '2024-11-13',
    featured: true
  },
  {
    id: '4',
    title: 'Complete Guide to Transformer Architecture in 2024',
    excerpt: 'Deep dive into the transformer architecture that powers modern AI, from attention mechanisms to practical implementation examples.',
    category: 'Tutorials',
    source: 'Towards Data Science',
    sourceUrl: 'https://towardsdatascience.com/',
    articleUrl: 'https://towardsdatascience.com/transformers-explained-visually-part-1-overview-of-functionality-95a6dd460452',
    imageUrl: 'https://images.unsplash.com/photo-1516116216624-53e697fedbea?w=800',
    publishedAt: '2024-11-12',
    featured: false
  },
  {
    id: '5',
    title: 'Building Production-Ready RAG Systems with LangChain',
    excerpt: 'Learn how to build robust Retrieval-Augmented Generation systems using LangChain, vector databases, and modern LLMs.',
    category: 'Programming',
    source: 'Analytics Vidhya',
    sourceUrl: 'https://www.analyticsvidhya.com/blog/',
    articleUrl: 'https://www.analyticsvidhya.com/blog/2023/08/what-is-retrieval-augmented-generation/',
    imageUrl: 'https://images.unsplash.com/photo-1587620962725-abab7fe55159?w=800',
    publishedAt: '2024-11-11',
    featured: false
  },
  {
    id: '6',
    title: 'Anthropic Claude 3.5 Achieves New Benchmarks in AI Safety',
    excerpt: 'Claude 3.5 sets new standards in constitutional AI, demonstrating improved alignment and reduced harmful outputs.',
    category: 'AI News',
    source: 'Anthropic News',
    sourceUrl: 'https://www.anthropic.com/news',
    articleUrl: 'https://www.anthropic.com/news/claude-3-5-sonnet',
    imageUrl: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=800',
    publishedAt: '2024-11-10',
    featured: false
  },
  {
    id: '7',
    title: 'Understanding Diffusion Models: From Theory to Practice',
    excerpt: 'Comprehensive guide to diffusion models, the technology behind DALL-E 3, Midjourney, and Stable Diffusion.',
    category: 'Machine Learning',
    source: 'Berkeley AI Research',
    sourceUrl: 'https://bair.berkeley.edu/blog/',
    articleUrl: 'https://bair.berkeley.edu/blog/2023/04/03/koala/',
    imageUrl: 'https://images.unsplash.com/photo-1686191128892-5e4495837250?w=800',
    publishedAt: '2024-11-09',
    featured: true
  },
  {
    id: '8',
    title: 'Top 10 Python Libraries for Machine Learning in 2024',
    excerpt: 'Essential Python libraries every ML engineer should know, from scikit-learn to cutting-edge frameworks.',
    category: 'Tools',
    source: 'KDnuggets',
    sourceUrl: 'https://www.kdnuggets.com/',
    articleUrl: 'https://www.kdnuggets.com/top-python-libraries-for-data-science',
    imageUrl: 'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=800',
    publishedAt: '2024-11-08',
    featured: false
  },
  {
    id: '9',
    title: 'Google Announces Gemini 2.0 with Enhanced Reasoning',
    excerpt: 'Google unveils Gemini 2.0, featuring improved multimodal capabilities and state-of-the-art performance across benchmarks.',
    category: 'AI News',
    source: 'Google AI Blog',
    sourceUrl: 'https://blog.google/technology/ai/',
    articleUrl: 'https://blog.google/technology/ai/google-gemini-ai-update-december-2024/',
    imageUrl: 'https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=800',
    publishedAt: '2024-11-07',
    featured: false
  },
  {
    id: '10',
    title: 'Fine-Tuning Large Language Models: Best Practices',
    excerpt: 'Comprehensive guide to fine-tuning LLMs for specific tasks, including dataset preparation and hyperparameter tuning.',
    category: 'Tutorials',
    source: 'Analytics Vidhya',
    sourceUrl: 'https://www.analyticsvidhya.com/blog/',
    articleUrl: 'https://www.analyticsvidhya.com/blog/2024/01/fine-tuning-large-language-models/',
    imageUrl: 'https://images.unsplash.com/photo-1515879218367-8466d910aaa4?w=800',
    publishedAt: '2024-11-06',
    featured: false
  }
];

export const mockVideos = [
  {
    id: 'v1',
    title: 'The Future of AI: What\'s Coming in 2025',
    videoId: '3spCFnMSGIY',
    videoUrl: 'https://www.youtube.com/watch?v=3spCFnMSGIY',
    channel: 'In The World of AI',
    channelUrl: 'https://www.youtube.com/@intheworldofai',
    thumbnail: 'https://img.youtube.com/vi/3spCFnMSGIY/maxresdefault.jpg',
    category: 'AI News',
    publishedAt: '2024-11-14'
  },
  {
    id: 'v2',
    title: 'Building Modern Web Apps with React 19',
    videoId: 'dQw4w9WgXcQ',
    videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
    channel: 'Midudev',
    channelUrl: 'https://www.youtube.com/@midudev',
    thumbnail: 'https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=800',
    category: 'Programming',
    publishedAt: '2024-11-13'
  },
  {
    id: 'v3',
    title: 'OpenAI DevDay 2024 - Full Keynote',
    videoId: 'example123',
    videoUrl: 'https://www.youtube.com/watch?v=example123',
    channel: 'OpenAI',
    channelUrl: 'https://www.youtube.com/@OpenAI',
    thumbnail: 'https://images.unsplash.com/photo-1677442135703-1787eea5ce01?w=800',
    category: 'AI News',
    publishedAt: '2024-11-12'
  },
  {
    id: 'v4',
    title: 'Machine Learning Fundamentals Explained',
    videoId: 'example456',
    videoUrl: 'https://www.youtube.com/watch?v=example456',
    channel: 'In The World of AI',
    channelUrl: 'https://www.youtube.com/@intheworldofai',
    thumbnail: 'https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?w=800',
    category: 'Tutorials',
    publishedAt: '2024-11-11'
  },
  {
    id: 'v5',
    title: 'Deep Learning with Python - Complete Course',
    videoId: 'example789',
    videoUrl: 'https://www.youtube.com/watch?v=example789',
    channel: 'In The World of AI',
    channelUrl: 'https://www.youtube.com/@intheworldofai',
    thumbnail: 'https://images.unsplash.com/photo-1587620962725-abab7fe55159?w=800',
    category: 'Tutorials',
    publishedAt: '2024-11-10'
  },
  {
    id: 'v6',
    title: 'JavaScript Tips and Tricks for 2024',
    videoId: 'exampleABC',
    videoUrl: 'https://www.youtube.com/watch?v=exampleABC',
    channel: 'Midudev',
    channelUrl: 'https://www.youtube.com/@midudev',
    thumbnail: 'https://images.unsplash.com/photo-1579468118864-1b9ea3c0db4a?w=800',
    category: 'Programming',
    publishedAt: '2024-11-09'
  }
];

export const categories = [
  { id: 'all', name: 'All', icon: 'Grid3x3' },
  { id: 'AI News', name: 'AI News', icon: 'Newspaper' },
  { id: 'Programming', name: 'Programming', icon: 'Code' },
  { id: 'Machine Learning', name: 'Machine Learning', icon: 'Brain' },
  { id: 'Research Papers', name: 'Research Papers', icon: 'FileText' },
  { id: 'Tools', name: 'Tools', icon: 'Wrench' },
  { id: 'Tutorials', name: 'Tutorials', icon: 'GraduationCap' }
];